<p-toast position="top-right" key="tracking-message"></p-toast>

<!--Start : Tracking From SI Details-->

<div *ngIf="display">
    <div class="p-text-center p-my-2">
        <h5 class="p-m-0 p-text-primary p-text-bold" *ngIf="!isLoading"> Shipment Tracking </h5>
    </div>

    <div class="p-pt-5 p-text-center p-d-none p-d-xl-block" *ngIf="isLoading" style="min-height: 20vw;">
        <div>
            <div class="p-text-secondary pi pi-spin pi-spinner"
                 style="font-size: 2rem"></div>
        </div>
        <div class="p-mt-4 p-font-11">
            <h5 class="p-text-light">Loading Tracking !</h5>
        </div>
    </div>

    <div class="p-grid p-p-2 p-text-secondary">
        <div class="p-col-6 p-md-3 p-xl-2"
             *ngFor="let trackingHeader of trackingDetails?.trackingDetailsHeader | keyvalue: originalOrder">
            <div>
                <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">
                    {{trackingHeader?.key ? trackingHeader?.key : 'NA'}}
                </h6>
            </div>
            <div class="p-text-secondary">
                {{trackingHeader?.value ? trackingHeader?.value : '-'}}
            </div>
        </div>
    </div>
    <!--    Start : Shipment Basic Details-->
<!--    <div *ngIf="!isLoading" class=" divider-bottom">-->
<!--        <div class="p-grid p-my-0">-->
<!--            <div class="p-col-6 p-pb-0 p-text-left">-->
<!--                <div class="fp-text-bold">Booking Number</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.bookingNumber ? tracking?.bookingNumber : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'AIR'  || shipmentType === 'Service Job'">-->
<!--                <div class="fp-text-bold">ETD</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.departureDate ? (tracking?.departureDate | date: 'dd-MMM-yyyy') : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left" *ngIf="shipmentType === 'AIR'  || shipmentType === 'Service Job'">-->
<!--                <div class="fp-text-bold">HAWB Number</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.hawbNumber ? tracking?.hawbNumber : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left" *ngIf="shipmentType === 'AIR'  || shipmentType === 'Service Job'">-->
<!--                <div class="fp-text-bold">ETA</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.arrivalDate ? (tracking?.arrivalDate | date: 'dd-MMM-yyyy') : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance' ">-->
<!--                <div class="fp-text-bold">Place Of Receipt</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.placeOfReceipt ? tracking?.placeOfReceipt : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance'">-->
<!--                <div class="fp-text-bold">HBL Number</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.hblNumber ? tracking?.hblNumber : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance' ">-->
<!--                <div class="fp-text-bold">Port of Loading</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.portOfLoading ? tracking?.portOfLoading : ' - '}}</div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="p-grid p-my-0">-->
<!--            <div class="p-col-6 p-pb-0 p-text-left">-->
<!--                <div class="fp-text-bold">Customer Ref No.</div>-->
<!--                <div-->
<!--                        [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.customerReferenceNumber ? tracking?.customerReferenceNumber : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance'">-->
<!--                <div class="fp-text-bold">Port of Discharge</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.portOfDischarge ? tracking?.portOfDischarge : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance'">-->
<!--                <div class="fp-text-bold">Vessel</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.vesselName ? tracking?.vesselName : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance'">-->
<!--                <div class="fp-text-bold">Final Place of delivery</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.finalPlaceOfDelivery ? tracking?.finalPlaceOfDelivery : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance' ">-->
<!--                <div class="fp-text-bold">Voyage</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.voyage ? tracking?.voyage : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left">-->
<!--                <div class="fp-text-bold">Transit Duration</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.transitDuration ? tracking?.transitDuration + 'Days' : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left"-->
<!--                 *ngIf="shipmentType === 'FCL' || shipmentType === 'LCL' || shipmentType === 'Transport' || shipmentType === 'Custom Clearance' ">-->
<!--                <div class="fp-text-bold">No. of Containers</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.numberOfContainers ? tracking?.numberOfContainers : ' - ' }}</div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="p-grid p-my-0" *ngIf="shipmentType === 'AIR'  || shipmentType === 'Service Job'">-->
<!--            <div class="p-col-6 p-pb-0 p-text-left">-->
<!--                <div class="fp-text-bold">Gross Weight</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.grossWeight ? tracking?.grossWeight : ' - '}}</div>-->
<!--            </div>-->
<!--            <div class="p-col-6 p-pb-0 p-text-left">-->
<!--                <div class="fp-text-bold">Flight No.</div>-->
<!--                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{tracking?.flightNumber ? tracking?.flightNumber : ' - '}}</div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
    <!--    End : Shipment Basic Details-->

    <!--    Start: Shipment Details Tracking-->
    <div *ngIf="!isLoading" class="p-mt-3">
        <p-timeline [value]="trackingDetailsArray" align="left" class="tracking-timeline"
                    styleClass="customized-timeline">
            <ng-template pTemplate="marker" let-event>
                    <span [class]="event?.enabled ? 'custom-marker' : 'custom-marker p-disabled fonts-opacity'"
                          style="border-radius: 5px;">
                        <img [src]="event.icon" alt="image-na">
                    </span>
            </ng-template>
            <ng-template pTemplate="content" let-event>
                <!--                | date : 'h:mm a'-->
                <p-card [class]="event?.enabled ? 'tracking-cards' :'tracking-cards p-disabled fonts-opacity' "
                        styleClass="p-mb-3 p-ml-2"
                        [header]="event.status"
                        [subheader]="(event.statusDateTime ? (event.statusDateTime | date: 'dd - MMM - yyyy h:mm a') : 'DD/MM/YYYY 00:00')">
                    <img *ngIf="event.image" [src]="'assets/showcase/images/demo/product/' + event.icon"
                         [alt]="event.name" class="p-shadow-2"/>
                </p-card>
            </ng-template>
        </p-timeline>
    </div>
    <!--    End: Shipment Details Tracking-->
</div>

<!--End : Tracking From SI Details-->
